import { BareActionContext } from 'vuex-typex'
import { ConvoState } from '../state'
import { RootState } from '../..'
import { IStatement } from '../../../model/statement'
import convoStore from '../convo-store'
import statementStore from '../../statement/statement-store'

export default async function removeFormStatement(context: BareActionContext<ConvoState, RootState>, statement: IStatement)
{
  const form = convoStore.state.convoForm

  if (form.statements.indexOf(statement) >= 0) {
    form.statements.splice(form.statements.indexOf(statement), 1)
    statementStore.dispatchSetStatementQuery()
  }

  return
}
